<div class="container main-container">
    <h2>Login</h2>
    <form novalidate (ngSubmit)="login()" [formGroup]="loginForm">
        <div class="form-group">
            <label class="col-md-2 control-label">E-mail</label>
            <div class="col-md-10">
                
                <input class="form-control" id="email" type="text" placeholder="E-mail (requerido)" formControlName="email"/>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Senha</label>
            <div class="col-md-10">
                <input class="form-control" id="senha" type="password" placeholder="Senha (requerido)" formControlName="senha"/>
            </div>
        </div>
        <div class="form-group">
            
            <div class="col-md-10">
               <span>
                   <button class="btn btn-success" id="Login" [disabled]="!loginForm.valid" type="submit">Login</button>
               </span>
            </div>
        </div>
    </form>
</div>
